// extracted by mini-css-extract-plugin
module.exports = {"container":"NoResults__container___2kexe","message":"NoResults__message___1PIfD","linked-message":"NoResults__linked-message___3Opkq"};